// Pets Module Types

// === Enums ===

export type PetType = 'DOG' | 'CAT' | 'BIRD' | 'OTHER';

export enum VaccineType {
  // Dogs
  RABIES = 'RABIES',
  DISTEMPER = 'DISTEMPER',
  PARVOVIRUS = 'PARVOVIRUS',
  LEPTOSPIROSIS = 'LEPTOSPIROSIS',
  BORDETELLA = 'BORDETELLA',
  HEPATITIS = 'HEPATITIS',
  // Cats
  FELINE_LEUKEMIA = 'FELINE_LEUKEMIA',
  FELINE_CALICIVIRUS = 'FELINE_CALICIVIRUS',
  FELINE_PANLEUKOPENIA = 'FELINE_PANLEUKOPENIA',
  FELINE_RHINOTRACHEITIS = 'FELINE_RHINOTRACHEITIS',
  // General
  DEWORMING = 'DEWORMING',
  OTHER = 'OTHER',
}

// === Vaccination Interface ===

export interface Vaccination {
  id: string;
  petId: string;
  vaccineType: VaccineType;
  vaccineName?: string;       // Custom name when type is OTHER
  appliedAt: string;          // ISO date YYYY-MM-DD
  nextDoseAt?: string;        // ISO date YYYY-MM-DD
  veterinarian?: string;
  clinic?: string;
  batchNumber?: string;       // Vaccine batch/lot number
  notes?: string;
  // Computed fields (from backend or calculated)
  isOverdue?: boolean;
  daysUntilNextDose?: number;
  createdAt?: string;
  updatedAt?: string;
}

// === Pet Interface ===

export interface Pet {
  id: string;
  ownerMemberId?: string;
  /** Unidad a la que pertenece (null si el backend no pudo resolver ninguna). */
  unitId?: string | null;
  /** Nombre de quién la registró (TenantMember.displayName) — útil porque se comparte con toda la casa. */
  ownerName?: string | null;
  name: string;
  type: PetType;
  breed?: string;
  color?: string;
  birthDate?: string;         // ISO date YYYY-MM-DD
  age?: number;               // Computed from birthDate
  chipId?: string;            // Microchip ID
  photoUrl?: string;
  photoFileId?: string;
  notes?: string;
  vaccinations?: Vaccination[];
  createdAt?: string;
  updatedAt?: string;
}

// === DTOs ===

export interface CreatePetDTO {
  name: string;
  type: PetType;
  breed?: string;
  color?: string;
  birthDate?: string;
  chipId?: string;
  photoUrl?: string;
  photoFileId?: string;
  notes?: string;
  /** Unidad a la que pertenece — solo relevante si el residente tiene más de una. */
  unitId?: string;
}

export interface UpdatePetDTO {
  name?: string;
  type?: PetType;
  breed?: string;
  color?: string;
  birthDate?: string;
  chipId?: string;
  photoUrl?: string;
  photoFileId?: string;
  notes?: string;
}

export interface CreateVaccinationDTO {
  vaccineType: VaccineType;
  vaccineName?: string;
  appliedAt: string;
  nextDoseAt?: string;
  veterinarian?: string;
  clinic?: string;
  batchNumber?: string;
  notes?: string;
}

export interface UpdateVaccinationDTO {
  vaccineType?: VaccineType;
  vaccineName?: string;
  appliedAt?: string;
  nextDoseAt?: string;
  veterinarian?: string;
  clinic?: string;
  batchNumber?: string;
  notes?: string;
}
